export default () => ({
  accessToken: null,
  canInteract: true,
  isBooting: true,
  account: null,
});
